import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/logo2.png';
import _imports_1 from '@/assets/images/QRCode.png';
import _imports_2 from '@/assets/images/beian.png';

import { inject } from 'vue';
const _withScopeId = n => (_pushScopeId("data-v-8d8cb196"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "cusFooter-bg"
};
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<img class=\"logo\" src=\"" + _imports_0 + "\" data-v-8d8cb196><div class=\"contactUs\" data-v-8d8cb196>联系我们</div><div class=\"content\" data-v-8d8cb196><div class=\"content-1\" data-v-8d8cb196><div data-v-8d8cb196>咨询热线：</div><div data-v-8d8cb196>152-8608-2545</div></div><div class=\"content-2\" data-v-8d8cb196><div data-v-8d8cb196>地址：</div><div data-v-8d8cb196>贵州省贵阳市观山湖区长岭街道贵阳国际金融中心1期商务区9号楼</div></div><div class=\"content-3\" data-v-8d8cb196><div data-v-8d8cb196>微信公众号：</div><img src=\"" + _imports_1 + "\" data-v-8d8cb196></div></div>", 3);
const _hoisted_5 = {
  class: "info"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Copyright © 2024 数智金源官网 shuzhijinyuan.com All Rights Reserved. ", -1));
const _hoisted_7 = {
  class: "beian"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "贵公网安备 52011502009089号", -1));
const _hoisted_10 = [_hoisted_8, _hoisted_9];
export default {
  __name: 'cusFooter',
  setup(__props) {
    const $screenWidth = inject('$screenWidth');
    const $screenSize = inject('$screenSize');
    function open(url) {
      window.open(url);
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = $event => open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=52011502009089'))
      }, _hoisted_10), _createElementVNode("span", {
        onClick: _cache[1] || (_cache[1] = $event => open('https://beian.miit.gov.cn/#/Integrated/index'))
      }, "备案号：黔ICP备2023017756号-1")])])]);
    };
  }
};